"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVideoQualitySelection = exports.getVideoQualitySelection = exports.VIDEO_QUALITY_PROFILES = exports.setNoiseEngine = exports.getNoiseEngine = exports.setNoiseSuppressionEnabled = exports.getNoiseSuppressionEnabled = exports.setMessageDeliveryMode = exports.getMessageDeliveryMode = exports.setAdaptiveQualityEnabled = exports.getAdaptiveQualityEnabled = exports.setVoiceTransportMode = exports.getVoiceTransportMode = exports.setVoiceEngine = exports.getVoiceEngine = exports.setRealtimeServerUrl = exports.getRealtimeServerUrl = exports.DEFAULT_REALTIME_SERVER_URL = void 0;
exports.DEFAULT_REALTIME_SERVER_URL = 'https://mail.teysas.com:3001';
const getRealtimeServerUrl = () => {
    if (typeof window === 'undefined')
        return exports.DEFAULT_REALTIME_SERVER_URL;
    let url = localStorage.getItem('meci_realtime_server_url') || exports.DEFAULT_REALTIME_SERVER_URL;
    // Eski kayıtlı IP/http adreslerini HTTPS alan adına yükselt (Mixed Content engeli)
    if (url.includes('193.111.125.190') || (window.location.protocol === 'https:' && url.startsWith('http://'))) {
        url = exports.DEFAULT_REALTIME_SERVER_URL;
        localStorage.setItem('meci_realtime_server_url', url);
    }
    return url;
};
exports.getRealtimeServerUrl = getRealtimeServerUrl;
const setRealtimeServerUrl = (url) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_realtime_server_url', url.trim());
    }
};
exports.setRealtimeServerUrl = setRealtimeServerUrl;
const getVoiceEngine = () => {
    if (typeof window === 'undefined')
        return 'meci';
    return localStorage.getItem('meci_voice_engine') || 'meci';
};
exports.getVoiceEngine = getVoiceEngine;
const setVoiceEngine = (engine) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_voice_engine', engine);
    }
};
exports.setVoiceEngine = setVoiceEngine;
const getVoiceTransportMode = () => {
    if (typeof window === 'undefined')
        return 'auto';
    const v = localStorage.getItem('meci_voice_transport_mode');
    return v === 'p2p' || v === 'relay' ? v : 'auto';
};
exports.getVoiceTransportMode = getVoiceTransportMode;
const setVoiceTransportMode = (mode) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_voice_transport_mode', mode);
    }
};
exports.setVoiceTransportMode = setVoiceTransportMode;
/** Uyarlanabilir kalite: bağlantı yavaşlayınca ses/görüntü otomatik düşürülür. */
const getAdaptiveQualityEnabled = () => {
    if (typeof window === 'undefined')
        return true;
    return localStorage.getItem('meci_voice_adaptive') !== 'false';
};
exports.getAdaptiveQualityEnabled = getAdaptiveQualityEnabled;
const setAdaptiveQualityEnabled = (enabled) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_voice_adaptive', String(enabled));
    }
};
exports.setAdaptiveQualityEnabled = setAdaptiveQualityEnabled;
const getMessageDeliveryMode = () => {
    if (typeof window === 'undefined')
        return 'websocket';
    return localStorage.getItem('meci_message_delivery_mode') || 'websocket';
};
exports.getMessageDeliveryMode = getMessageDeliveryMode;
const setMessageDeliveryMode = (mode) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_message_delivery_mode', mode);
    }
};
exports.setMessageDeliveryMode = setMessageDeliveryMode;
const getNoiseSuppressionEnabled = () => {
    if (typeof window === 'undefined')
        return true;
    return localStorage.getItem('meci_voice_noise_suppression') !== 'false';
};
exports.getNoiseSuppressionEnabled = getNoiseSuppressionEnabled;
const setNoiseSuppressionEnabled = (enabled) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_voice_noise_suppression', String(enabled));
    }
};
exports.setNoiseSuppressionEnabled = setNoiseSuppressionEnabled;
const getNoiseEngine = () => {
    if (typeof window === 'undefined')
        return 'krisp';
    return localStorage.getItem('meci_voice_noise_engine') || 'krisp';
};
exports.getNoiseEngine = getNoiseEngine;
const setNoiseEngine = (engine) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_voice_noise_engine', engine);
    }
};
exports.setNoiseEngine = setNoiseEngine;
exports.VIDEO_QUALITY_PROFILES = {
    '1080p': { width: 1920, height: 1080, frameRate: 60, bitrateMax: 4000 },
    '720p': { width: 1280, height: 720, frameRate: 30, bitrateMax: 2000 },
    '480p': { width: 854, height: 480, frameRate: 30, bitrateMax: 1000 },
    '360p': { width: 640, height: 360, frameRate: 24, bitrateMax: 800 },
    '240p': { width: 426, height: 240, frameRate: 20, bitrateMax: 500 },
    '120p': { width: 160, height: 120, frameRate: 15, bitrateMax: 200 },
};
const getVideoQualitySelection = () => {
    if (typeof window === 'undefined')
        return 'auto';
    return localStorage.getItem('meci_video_quality') || 'auto';
};
exports.getVideoQualitySelection = getVideoQualitySelection;
const setVideoQualitySelection = (quality) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('meci_video_quality', quality);
    }
};
exports.setVideoQualitySelection = setVideoQualitySelection;
